/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.10",
    versionName: "0.2.0-nightly.2026.3.10",
    versionChannel: "nightly",
    buildDate: "2026-03-10T00:08:42.454Z",
    commitHash: "2d8d38ab22925820d195648a0be3131e1e7bf36f",
};
